import { apiUrl } from "../ApiManager/AxiosHeaders";

function normalizePagination(pagination = {}) {
  return {
    currentPage: pagination.currentPage ?? pagination.current_page ?? 1,
    perPage: pagination.perPage ?? pagination.per_page ?? 10,
    total: pagination.total ?? 0,
    lastPage: pagination.lastPage ?? pagination.last_page ?? 1,
  };
}

function buildIntakeParams(intakeIds) {
  const ids = Array.isArray(intakeIds)
    ? intakeIds.filter((id) => id != null && id !== "")
    : [];
  if (ids.length === 0) return {};
  return { intakeIds: ids.map((id) => Number(id)) };
}

export async function fetchProviderInsightsProviders({
  list = "active",
  intakeIds,
  page = 1,
  perPage = 10,
  providerId,
  courseId,
  searchTerm,
  providerName,
  location,
} = {}) {
  const response = await apiUrl.get("/provider-insights", {
    params: {
      view: "summary",
      list,
      page,
      perPage,
      ...buildIntakeParams(intakeIds),
      providerId: providerId || undefined,
      courseId: courseId || undefined,
      searchTerm: searchTerm || undefined,
      providerName: providerName || undefined,
      location: location || undefined,
    },
  });

  const payload = response?.data;
  if (!payload?.status) {
    throw new Error(payload?.message || "Failed to load provider insights.");
  }

  return {
    list: payload?.data?.list ?? list,
    tabCounts: payload?.data?.tabCounts ?? { active: 0, inactive: 0 },
    totals: payload?.data?.totals ?? {},
    providers: payload?.data?.providers ?? [],
    pagination: normalizePagination(payload?.pagination),
  };
}

export async function fetchProviderInsightsApplicationStatusHistory(applicationId) {
  const response = await apiUrl.get("/provider-insights", {
    params: {
      view: "status_history",
      applicationId,
    },
  });

  const payload = response?.data;
  if (!payload?.status) {
    throw new Error(payload?.message || "Failed to load status history.");
  }

  return payload?.data ?? {};
}

export async function fetchProviderInsightsApplications({
  segment,
  providerId,
  intakeIds,
  page = 1,
  perPage = 10,
  courseId,
  searchTerm,
  location,
} = {}) {
  const response = await apiUrl.get("/provider-insights", {
    params: {
      view: "applications",
      segment,
      page,
      perPage,
      providerId: providerId || undefined,
      ...buildIntakeParams(intakeIds),
      courseId: courseId || undefined,
      searchTerm: searchTerm || undefined,
      location: location || undefined,
    },
  });

  const payload = response?.data;
  if (!payload?.status) {
    throw new Error(payload?.message || "Failed to load applications.");
  }

  return {
    data: payload?.data ?? [],
    pagination: normalizePagination(payload?.pagination),
  };
}

/** @deprecated use fetchProviderInsightsProviders */
export async function fetchProviderInsightsSummary(params = {}) {
  return fetchProviderInsightsProviders(params);
}
